export const BranchOptions = [
  "Chama",
  "Springer",
  "Questa",
  "Lordsburg",
  "Mora",
  "Angelfire",
];
export const RoleOptions = ["PHARMACIST", "TECHNICIAN"];
export const StatusOptions = ["Active", "Inactive"];
export const GenderOptions = ["M", "F"];
